<template>
  <Card class="feature-table__card" :clickable="false">
    <h3 class="text-h2 mb-16">You've sent the maximum number of requests today</h3>
    <p class="text-body mb-8">To connect with unlimited sitters upgrade to Premium</p>
    <Button
      value="Upgrade to message"
      variant="primary"
      size="medium"
      class="w-full mt-16 mb-32"
      href="/account/seekers/upgrade"
      @click="$emit('upgrade-click')"
    />
    <div class="border-1 border-solid border-grey-divider-subdued rounded-xl p-16">
      <FeatureTable :tableHeadings="tableHeadings" class="text-small">
        <FeatureTableRow
          v-for="(row, index) in featureTableRows"
          :key="row.title"
          :index="index"
          class="text-small text-gray-body text-center"
        >
          <td scope="row" :class="index % 2 === 0 ? 'py-10' : 'py-12'" class="pl-16 text-left text-m">
            {{ row.title }}
          </td>
          <td scope="row">
            <CheckmarkList class="text-center text-m" alt="available" />
          </td>
          <td scope="row">
            <CheckmarkList v-if="row.secondColumn === true" alt="available" />
            <LockIcon v-else color="#8A8A8F" :width="16" :height="16" alt="locked" />
          </td>
        </FeatureTableRow>
      </FeatureTable>
    </div>
  </Card>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import FeatureTable from '@/components/feature_table/FeatureTable.vue';
import FeatureTableRow from '@/components/feature_table/FeatureTableRow.vue';
import LockIcon from '@/graphics/icons/LockIcon.vue';

interface FeatureTableRowData {
  title: string;
  firstColumn: boolean;
  secondColumn: boolean;
}

export default {
  name: 'RecruitLimit',
  components: {
    Button,
    Card,
    CheckmarkList,
    FeatureTable,
    FeatureTableRow,
    LockIcon,
  },
  data(): { tableHeadings: string[]; featureTableRows: FeatureTableRowData[] } {
    return {
      tableHeadings: ["What's included", 'Premium', 'Current'],
      featureTableRows: [
        { title: 'Post a job', firstColumn: true, secondColumn: true },
        { title: 'Unlimited sitter search', firstColumn: true, secondColumn: true },
        { title: 'Read applications', firstColumn: true, secondColumn: true },
        { title: 'Message sitters', firstColumn: true, secondColumn: false },
        { title: 'Request interviews', firstColumn: true, secondColumn: false },
        { title: 'Book unique activities', firstColumn: true, secondColumn: false },
      ],
    };
  },
};
</script>
